import { render, staticRenderFns } from "./PropertyWrapper.vue?vue&type=template&id=c5d58b64&"
import script from "./PropertyWrapper.vue?vue&type=script&lang=js&"
export * from "./PropertyWrapper.vue?vue&type=script&lang=js&"
import style0 from "./PropertyWrapper.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports